import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import RedirectIfMissing from "../containers/RedirectIfMissing";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { withDataMapping } from "../util/hocs/withDataMapping";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { object, number } from "yup";
import PURCHASEIRQDownPaymentView from "../views/IrqDownPaymentView";
import { getDownPaymentMinimum } from "../util/getDownPaymentMinimum";
import AppRoutes from "../config/AppRoutes";
import { LoadingIndicator } from "../atoms/LoadingIndicator";
import StatusCheck from "../components/StatusCheck";
import { CountyLimitsContext } from "../context/CountyLimitsContext";

class BuildIrqDownPaymentPage extends Component {
  static contextType = CountyLimitsContext;

  componentDidMount() {
    this.context.fetchCountyLimits();
  }

  render() {
    const { data } = this.props;
    const { countyLimits } = this.context;
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    if (countyLimits === null) {
      return (
        <div className="page-wrapper">
          <LoadingIndicator label="Fetching page data..." />
        </div>
      );
    }

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <RedirectIfMissing
          id="buildIrq"
          fieldName="price"
          redirectUrl={AppRoutes.BUILD_IRQ_PROPERTY_VALUE_PAGE}
        >
          <EditableDataContainer
            id="buildIrq"
            submitEndpoint={submitEndpoint}
            mutateRedux="always"
            isCreate
            isStep
            validationSchema={object().shape({
              downPayment: number()
                .integer()
                .test(
                  "downPayment",
                  "You must exceed the minimum down payment required.",
                  function (value) {
                    if (!value) return false;
                    const firstTimeBuyer =
                      localStorage.getItem("firstTimeBuyer");
                    const downPaymentMinimum = getDownPaymentMinimum({
                      countyLimits,
                      county: data.county,
                      state: data.state,
                      countyFips: data.countyFips,
                      stateFips: data.stateFips,
                      loanAmount: data.price - value,
                      propertyType: data.propertyType,
                      occupancyType: data.occupancyType,
                      lookingTo: "Purchase",
                      isFirstTimeHomebuyer:
                        firstTimeBuyer === null ? "false" : firstTimeBuyer,
                    });
                    const minimum = data.price * (downPaymentMinimum / 100);
                    return value >= minimum;
                  }
                )
                .required(),
            })}
          >
            <PURCHASEIRQDownPaymentView
              content={contentMap.BuildIrqDownPaymentPage}
              navigationsAway={customNavigationMap.BuildIrqDownPaymentPage}
            />
          </EditableDataContainer>
        </RedirectIfMissing>
      </div>
    );
  }
}

export default withRouterUtilities(withDataMapping(BuildIrqDownPaymentPage));
